import { propagationAxios } from 'trace-propagation';

import {
    Configuration,
    InvoiceApi,
    PlanApi,
    SubscriptionApi,
    TransactionApi,
    UserApi,
    LegacySubscriptionApi,
    CreditApi,
    PromoApi,
} from '@videoblocks/subscription-service-client';

const basePath = process.env.SUBSCRIPTION_SERVICE_HOST ?? 'http://localhost:4020';
export const subscriptionServiceConfig = new Configuration({ basePath });

// `propagationAxios` forwards incoming propagation headers to
// subscription-service for Signadot sandbox routing.
export const userApi = new UserApi(subscriptionServiceConfig, undefined, propagationAxios);
export const transactionApi = new TransactionApi(subscriptionServiceConfig, undefined, propagationAxios);
export const planApi = new PlanApi(subscriptionServiceConfig, undefined, propagationAxios);
export const subscriptionApi = new SubscriptionApi(subscriptionServiceConfig, undefined, propagationAxios);
export const invoiceApi = new InvoiceApi(subscriptionServiceConfig, undefined, propagationAxios);
export const legacySubscriptionApi = new LegacySubscriptionApi(subscriptionServiceConfig, undefined, propagationAxios);
export const creditApi = new CreditApi(subscriptionServiceConfig, undefined, propagationAxios);
export const promoApi = new PromoApi(subscriptionServiceConfig, undefined, propagationAxios);
